module.exports = __webpack_public_path__ + "img/firestone1.84f88e33.png";